// src/stores/useLayerRegistryStore.js

import { create } from "zustand";

export const useLayerRegistryStore = create((set) => ({
    layers: {}, // key: layerId → descriptor + UI state

    registerLayers: (incoming, opts = {}) => {

        const arr = Array.isArray(incoming) ? incoming.filter(Boolean) : [];

        set((state) => {

            let nextLayers = {};

            // ------------------------------------------------
            // preserve layers not being replaced
            // ------------------------------------------------
            if (!opts.replaceScope) {
                nextLayers = { ...state.layers };
            } else {
                for (const layer of Object.values(state.layers)) {
                    if (layer.scope !== opts.replaceScope) {
                        nextLayers[layer.id] = layer;
                    }
                }
            }

            // ------------------------------------------------
            // register incoming layers
            // ------------------------------------------------
            for (const layer of arr) {

                nextLayers[layer.id] = {
                    ...layer,
                    visible: layer.visible ?? layer.default_visible ?? false
                };

            }

            return { layers: nextLayers };

        });

    },

    clearProjectScopedLayers: () =>
        set((state) => {
            const next = {};

            Object.values(state.layers).forEach((layer) => {
                if (layer.scope === "global") {
                    next[layer.id] = layer;
                }
            });

            return { layers: next };
        }),

    toggleLayer: (id) => {
        set((state) => {
            const next = { ...state.layers };
            const layer = next[id];
            if (!layer) return state;

            // Toggle only this layer
            next[id] = { ...layer, visible: !layer.visible };

            return { layers: next };
        });
    },

    setLayerVisibilityById: (layerId, visible) =>
        set((state) => {
            const layer = state.layers[layerId];
            if (!layer) return state;

            return {
                layers: {
                    ...state.layers,
                    [layerId]: {
                        ...layer,
                        visible
                    }
                }
            };
        }),

    setLayerVisibilityBatch: (layerIds, visible) =>
        set((state) => {
            let changed = false;
            const next = { ...state.layers };

            layerIds.forEach((id) => {
                const layer = next[id];
                if (!layer) return;

                if (layer.visible !== visible) {
                    next[id] = {
                        ...layer,
                        visible
                    };
                    changed = true;
                }
            });

            return changed ? { layers: next } : state;
        }),

}));